import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const BELL_PANEL_NAME = 'bellPanel';

/**
 * Right side panel « Notifications » (centre de notifications, cloche de la
 * barre du haut). Offered to every plan and every role. The panel holds no
 * input data: it loads the notifications of the authenticated user itself.
 * The result is always `false`.
 */
@Injectable({ providedIn: 'root' })
export class BellPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  get isOpen(): boolean {
    return this._isOpen$.value;
  }

  open(): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(BELL_PANEL_NAME);
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  /** Bell button of the toolbar: a second click closes the panel. */
  toggle(): void {
    if (this.isOpen) {
      this.emitResult(false);
      return;
    }
    this.open();
  }

  getData(): null {
    return null;
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(BELL_PANEL_NAME);
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._isOpen$.next(false);
  }
}
